<template>
  <component
    :is="tag"
    :class="['raw-html', { '-pre-line': preserveBreaks, '-align-left': alignLeft }]"
  >
    <slot />
  </component>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
  name: 'RawHtml',
  props: {
    html: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'div',
    },
    section_bg: {
      type: String,
      default: '',
    },
  },
  watch: {
    html: {
      immediate: true,
      handler: 'renderHTML',
    },
  },
  methods: {
    renderHTML() {
      this.$nextTick(() => {
        this.$el.innerHTML = ''

        if (!this.html) return
        this.$el.insertAdjacentHTML('beforeend', DOMPurify.sanitize(this.html))

        this.$el.querySelectorAll('a[href^="http"]').forEach((externalLink) => {
          externalLink.target = '_blank'
          externalLink.rel = 'noopener'
        })
      })
    },
  },
}
</script>
